export default "__VITE_ASSET__D7PyPm3n__"